<template>
  <div class="menu-item-r">
    <div class="v-em-header font-size-16">
      <!-- <div class="v-nav-wrap">
        <label>浏览记录</label>
        <el-select class="m-l-12" v-if="this.accType !== 'person'" v-model="pathType" @change="pathChange" size="small">
          <el-option value='/footprint/product' :label="$t('footprints.product')">{{$t('footprints.product')}}</el-option>
          <el-option value='/footprint/exhibitor' :label="$t('footprints.exhibitor')">{{$t('footprints.exhibitor')}}</el-option>
        </el-select>
      </div> -->

      <div class="v-nav-wrap">
        <el-button size="small" v-if="this.accType === 'person'">
          {{ $t('footprints.person') }}
        </el-button>

        <el-button
          :class="{ 'el-button--primary': accType === 'exhibitor', 'el-button--primary-empty': accType !== 'exhibitor' }"
          type="primary"
          size="small"
          v-if="subjectType === 'VISITOR'"
          @click="switchFav('exhibitor')"
          >{{ $t('footprints.exhibitor') }}</el-button
        >

        <el-button
          :class="{ 'el-button--primary': accType === 'product', 'el-button--primary-empty': accType !== 'product' }"
          type="primary"
          size="small"
          v-if="subjectType === 'VISITOR'"
          @click="switchFav('product')"
          >{{ $t('footprints.product') }}</el-button
        >
      </div>
    </div>
    <div v-if="this.accType == 'person'">
      <div class="bl-find-list" v-loading="loading">
        <div class="bl-container">
          <el-row :gutter="30">
            <el-col :xs="8" :sm="8" :md="8" v-for="(item, index) in dataList" :key="item.visitorId">
              <VisitorCard showType="footprint" :index="index" :vData="item" @collect="collectEvent_v" @invite="inviteEvent_v" @details="detailsEvent" @msg="msgEvent" />
            </el-col>
          </el-row>
          <hNoData v-if="dataList.length == 0"></hNoData>
        </div>
        <div class="bl-container">
          <el-pagination
            v-if="dataList.length > 0"
            background
            @current-change="handleCurrentChange"
            :page-size="query.pageRows"
            :current-page.sync="query.pageNum"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            class="bl-page"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-if="this.accType == 'exhibitor'" class="v-exhibits-management-wrap">
      <div class="v-exhibits-management-list" v-loading="loading">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(item, index) in dataList" :key="item.productId">
            <ExhibitorCard
              class="v-em-card"
              :index="index"
              :vData="item"
              :slides="3"
              @collect="collectEvent_v"
              @invite="inviteEvent_a"
              @details="detailsEvent"
              @msg="msgEvent_a"
              @live="liveEvent(item.lived)"
            >
            </ExhibitorCard>
          </el-col>
        </el-row>
        <hNoData v-if="dataList.length == 0"></hNoData>
      </div>
      <div class="bl-container">
        <el-pagination
          v-if="dataList.length > 0"
          background
          @current-change="handleCurrentChange"
          :page-size="query.pageRows"
          :current-page.sync="query.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="query.total"
          class="bl-page"
        ></el-pagination>
      </div>
    </div>
    <div v-if="this.accType == 'product'" class="v-exhibits-management-wrap">
      <div class="v-exhibits-management-list" v-loading="loading">
        <el-row :gutter="30">
          <el-col :xs="6" :sm="6" :md="6" v-for="(item, index) in dataList" :key="item.productId">
            <ExhibitCard :slides="5" class="v-em-card" @callback="callback" :index="index" :vData="item">
              <div slot="exhibitsInfo" class="text-right theme-icon-color v-em-list">
                <div class="flex">
                  <div class="pointer zhibo-pointer" v-if="item['liveState']" @click.stop="callback({ type: 'live', data: item, index })">
                    <span class="iconfont iconzhibo"></span>
                    <span class="font-size-12">{{liveStatusText(item.live)}}</span>
                  </div>
                  <div v-else></div>
                  <div class="font-size-14 v-pointer-view" v-if="item.pageView"><i class="el-icon-view"></i>&nbsp;&nbsp;{{ item.pageView || 0 }}</div>
                </div>
                <!-- <div class="pointer disabled" v-if="item['invite']" @click.stop>
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('finds.invited') }}</span>
                </div>
                <div class="pointer" v-else @click.stop="callback({ type: 'invite', data: item, index })">
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('invite') }}</span>
                </div>
                <div class="pointer" @click.stop="callback({ type: 'details', data: item })">
                  <span class="iconfont iconicon_huabanfuben theme-icon-primary-color"></span>
                  <span>{{ $t('details') }}</span>
                </div> -->
              </div>
              <div slot="footer" class="v-em-footer flex-end">
                <!-- <div class="pointer" @click.stop="callback({ type: 'message', data: item, index })">
                  <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
                  <span>{{ $t('message') }}</span>
                </div> -->
                <!-- <div class="pointer disabled" v-if="item['invite']" @click.stop>
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('finds.invited') }}</span>
                </div>
                <div class="pointer" v-else @click.stop="callback({ type: 'invite', data: item, index })">
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('invite') }}</span>
                </div> -->
                <div class="pointer" @click.stop="callback({ type: 'details', data: item })">
                  <span class="el-icon-tickets theme-icon-primary-color"></span>
                  <span>{{ $t('details') }}</span>
                </div>
              </div>
            </ExhibitCard>
          </el-col>
        </el-row>
        <hNoData v-if="dataList.length == 0"></hNoData>
      </div>
      <div class="bl-container">
        <el-pagination
          v-if="dataList.length > 0"
          background
          @current-change="handleCurrentChange"
          :page-size="query.pageRows"
          :current-page.sync="query.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="query.total"
          class="bl-page"
        ></el-pagination>
      </div>
    </div>
    <ChatWithExhibitor @invite="submitInvite" :action="action" />
    <v-chat-width-employee-tim v-if="isTIM" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { listPerson, listActor, listProduct } from '@/api/footprint'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import hNoData from '@/components/hNoData'
import VisitorCard from '@/components/card/VisitorCard'
import ExhibitCard from '@/components/card/ExhibitCard'
import ExhibitorCard from '@/components/card/ExhibitorCard'
import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'

export default {
  name: 'findList',
  mixins: [eventMixin, inviteMixin],
  components: {
    VisitorCard,
    hNoData,
    ExhibitCard,
    ExhibitorCard,
    'v-chat-width-employee-tim': ChatWithEmployeeTim
  },
  data() {
    return {
      products: [],
      exhibitors: [],
      loading: false,
      query: {
        pageNum: 1,
        pageRows: this.$route.params.type == 'exhibitor' ? 6 : this.$route.params.type == 'product' ? 12 : 12,
        total: 0
      },
      dataList: [],
      identity: this.$route.params ? this.$route.params.type : 'vistor',
      accType: this.$route.params ? this.$route.params.type : '',
      pathType: this.$route.path
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'subjectType']),
    ...mapGetters(['language', 'isLogin', 'isTIM' ]),
    ...{
      iType: function() {
        if (this.identity == 'person') return 'VISITOR'
        if (this.identity == 'product') return 'PRODUCT'
        if (this.identity == 'exhibitor') return 'ACTOR'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchDataList()
    })
  },
  methods: {
    // 更换展品，展商路由
    pathChange(value) {
      this.$router.replace(value)
    },
    switchFav(type) {
      if (type === 'exhibitor') {
        this.$router.push('/footprint/exhibitor')
      }
      if (type === 'product') {
        this.$router.push('/footprint/product')
      }
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    // 页码 change
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.fetchDataList()
    },
    // 获取列表
    fetchDataList() {
      this.loading = true
      if (this.accType == 'person') {
        // 获取 客商列表
        listPerson({
          ...this.query,
          exhibitorId: this.exhibitorId,
          showType: 'PERSON_LIST'
        })
          .then(res => {
            return res.data
          })
          .then(res => {
            if (res.data) {
              let data = res.data
              this.query.total = data.total || 0
              this.query.pages = data.pages || 0
              this.dataList = data.list || []
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else if (this.accType == 'product') {
        this.getList()
      } else if (this.accType == 'exhibitor') {
        this.getExhList()
      }
    },
    // 获取展商列表
    getExhList() {
      listActor({
        ...this.query,
        exhibitorId: this.exhibitorId,
        showType: 'ACTOR_LIST'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.query.total = res.data.total || 0
            this.query.currentPage = res.data.pageNum || 0
            this.dataList = res.data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取产品列表
    getList() {
      listProduct({
        ...this.query,
        exhibitorId: this.exhibitorId,
        showType: 'PRODUCT_LIST'
      })
        .then(res => {
          if (res.data && res.data.data) {
            this.query.total = res.data.data.total
            this.query.currentPage = res.data.data.pageNum
            this.dataList = res.data.data.list
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 展品卡片的回调事件
    callback(res) {
      if (res.type == 'message') {
        let data = res.data
        data.atrName = data.exhibitorName
        this.msgEventExh(data, null, 'products')
      } else if (res.type == 'invite') {
        this.inviteEventExh(res.data, res.index, 'products')
      } else if (res.type == 'collect') {
        this.collectEvent(
          {
            id: res.data.collectionId,
            deleted: res.data.collected,
            collectionSubjectType: this.iType,
            collectionSubjectId: res.data.id
          },
          res.index
        )
      } else if (res.type == 'details') {
        this.detailsEvent(res.data)
      } else if (res.type == 'live') {
        this.liveEvent(res.data.liveId)
      }
    },
    // 客商 收藏
    collectEvent_v(params, index, data) {
      params.collectionSubjectId = data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 客商 邀约
    inviteEvent_v(params, index, data) {
      params.userId = data.id
      this.inviteEvent(params, index)
    },
    // 客商 消息
    msgEvent(data, index) {
      data.userAccountId = data.easemobAccount
      if (!data.userAccountId) {
        this.$notify.warning(this.$t('footprints.userAccountId'))
        return false
      }
      data.psjName = data.visitorName
      data.psjRank = data.post
      data.psjComName = data.corporateName
      data.headPortrait = data.headImage
      this.msgEventPerson(data, index)
    },
    // 详情
    detailsEvent(data) {
      if(this.accType == 'exhibitor') {
        this.pageDetail(data, 'actor')
      } else {
        this.pageDetail(data, this.accType)
      }
    },
    // 展商 邀约
    inviteEvent_a(params, index, data) {
      data.exhibitorId = data.id
      data.exhibitorName = data.exhibitorName || data.name || data.atrName
      this.inviteEventExh(data, index, 'exhibitors')
    },
    // 展商 消息
    msgEvent_a(data) {
      data.exhibitorId = data.id
      data.atrName = data.atrName || data.exhibitorName || data.name
      this.msgEventExh(data, null, 'exhibitors')
    }
  }
}
</script>

<style lang="stylus" scoped>
.bl-find-list
  padding-bottom 30px
.v-nav-wrap
  width 100%
  max-width $container-width
  margin 0 auto
  padding-left 15px
  padding-right 15px
.v-exhibits-management-wrap
  width 100%
  max-width $container-width
  margin 0 auto
  padding 0 15px 40px 15px
  padding-right: 0px;
  .v-em-header
    // padding:40px 0;
    >div
      margin-right 24px
    .el-select
      margin-left 12px
    .v-audit-status-1
      color $color-main
      margin-left 4px
    .v-audit-status-2
      color $color-blue-50
      margin-left 4px
    .v-audit-status-3
      color $color-red-f5
      margin-left 4px
  .v-exhibits-management-list
    flex-wrap wrap
    .v-em-card
      margin 0 15px 25px 0
      &:nth-child(3n+0)
        margin-right 0
      @media screen and (max-width: $container-width)
        &:nth-child(3n+0)
          margin-right 15px
        &:nth-child(2n+0)
          margin-right 0
  .v-em-list
    padding 8px 8px
  .v-em-footer
    >div
      margin-left 15px
  .el-pagination
    text-align right
</style>
